export const HANDLE_BUTTON_HEIGHT = 40;
export const ADDRESS_SEARCH_BAR_HEIGHT = 60;

export const POI_LIST_PAGE_DATASHEET_HEIGHT_OFFSET
	= HANDLE_BUTTON_HEIGHT + ADDRESS_SEARCH_BAR_HEIGHT;
